import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetSalesQuotation = createAsyncThunk(  
    'OrderHistory/SalesQuotation',
    async ({offsetValue}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`SalesHistory/GetSQHistory?offsetValue=${offsetValue}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  export const GetSalesOrder = createAsyncThunk(  
    'OrderHistory/SalesOrder',
    async ({offsetValue}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`SalesHistory/GetSOHistory?offsetValue=${offsetValue}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  export const GetOrderHistory = createAsyncThunk(  
    'OrderHistory/GetHistory',
    async ({docEntry}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`SalesHistory/GetHistory?DocEntry=${docEntry}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  export const GetQuotationDetails = createAsyncThunk(  
    'OrderHistory/GetQuotationDetails',
    async ({docEntry,DocType}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`SalesHistory/GetQuotation?DocEntry=${docEntry}&DocType=${DocType}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  export const GetsearchHistory = createAsyncThunk(  
    'HistoryPage/hisorybySearch',
    async ({searchValue,tab}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`SalesHistory/GetHistoryBySearch?searchText=${searchValue}&DocType=${tab}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );